<template>
  <!-- eslint-disable vue/no-template-shadow -->
  <GModal
    v-show="showModalBrands"
    ref="modalFilterBrand"
    class="modal--filter-by-brand"
    :class="{ 'modal--full-fixed': !isDesktop }"
  >
    <div slot="header" class="modal-header-container">
      <button type="button" class="close-button" aria-label="Close">
        <img v-if="isDesktop" src="/assets/img/icons/close-modal.svg" alt="Close" @click.prevent="closeModal" />
        <img v-else src="/assets/img/arrow_left.svg" alt="Back" @click.prevent="closeModal" />
      </button>
      <h2 class="modal-heading">Brand From {{ origin.toUpperCase() }}</h2>
    </div>

    <div slot="body" class="content">
      <div class="mega-menu-wrapper">
        <div class="brands-menu-left">
          <div class="search">
            <input
              v-model="keyword"
              type="text"
              name="search"
              autocomplete="off"
              placeholder="Search Brand..."
              class="input-search"
              @keyup="onKeyupSearchbrand"
            />
            <span class="icon-search"></span>
          </div>
          <template v-if="$SO.size(allBrands)">
            <div class="search-by-alpha">
              <a
                v-for="(letter, key) in letters"
                :key="key"
                class="brand-tag"
                :class="[{ active: letter.isActive || selectedLetter === key }, { disabled: !letter.isActive }]"
                @click="toLetter(key)"
              >
                {{ key }}
              </a>
            </div>
            <div id="brand-value-origin" class="brand-value">
              <div class="brand-val-list">
                <template v-for="(item, key) in filteredBrands.data">
                  <h4 :id="'brand-letter-' + key.toLowerCase()" :key="'brand-letter-' + key.toLowerCase()">
                    {{ key }}
                  </h4>
                  <!-- eslint-disable-next-line vue/require-v-for-key -->
                  <ul>
                    <li
                      v-for="(brand, key) in item"
                      :id="buildIdElBrand(brand, key)"
                      :key="key"
                      :class="[{ hidden: brand.isHidden }, 'for-br-' + brand.name[0].toLowerCase()]"
                    >
                      <router-link
                        :to="`/brand/${brand.my_soco_sql_id}/${$options.filters.slug(brand.name)}`"
                        @click.native="selectBrand"
                      >
                        {{ brand.name.toUpperCase() }}
                      </router-link>
                    </li>
                  </ul>
                </template>
              </div>
            </div>
          </template>
          <div v-else class="gfmp-brand-value">
            <div style="margin-top: 15px"></div>
            <GFMP
              v-for="i in 2"
              :key="`brand-value-${i}`"
              :styles="{
                minHeight: '136px',
                width: '100%',
                marginBottom: '14px',
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'modal-brands',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    allBrands: {
      required: false,
      type: Array,
      default: () => [],
    },
    origin: {
      required: false,
      type: String,
      default: '',
    },
  },
  data() {
    return {
      filterBrands: [],
      listsBrandsFinals: [],
      clickedBrand: '',
      searchText: '',
      keyword: '',
      selectedLetter: '',
      isLoadingFinishMostReviewBrand: false,
      activeTab: 0,
    };
  },
  computed: {
    showModalBrands() {
      return this.$store.state.modal.isModalShow.brands;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    filteredBrands() {
      const brands = this.listsBrandsFinals;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.isEmptyWhenTypingBrand = false;
      if (this.brandSearch && this.brandSearch.toString().length) {
        const newBrand = brands.filter((brand) => {
          return this.brandSearch
            .toString()
            .toLowerCase()
            .split(' ')
            .every((v) => brand.name.toLowerCase().includes(v));
        });
        if (!newBrand.length) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.isEmptyWhenTypingBrand = true;
        }
        return newBrand;
      } else {
        const res = brands.reduce(
          (acc, item) => {
            const l = item.name[0];
            if (acc.data[l]) {
              acc.data[l].push(item);
            } else {
              Object.assign(acc.data, { [l]: [item] });
            }
            return acc;
          },
          { data: {} }
        );
        return res;
      }
    },
    letters() {
      const letters = {
        '#': { isActive: false },
        a: { isActive: false },
        b: { isActive: false },
        c: { isActive: false },
        d: { isActive: false },
        e: { isActive: false },
        f: { isActive: false },
        g: { isActive: false },
        h: { isActive: false },
        i: { isActive: false },
        j: { isActive: false },
        k: { isActive: false },
        l: { isActive: false },
        m: { isActive: false },
        n: { isActive: false },
        o: { isActive: false },
        p: { isActive: false },
        q: { isActive: false },
        r: { isActive: false },
        s: { isActive: false },
        t: { isActive: false },
        u: { isActive: false },
        v: { isActive: false },
        w: { isActive: false },
        x: { isActive: false },
        y: { isActive: false },
        z: { isActive: false },
      };

      const isAlphabet = (char) => char.match(/^[A-Za-z]+$/);
      this.listsBrandsFinals
        .filter((item) => !item['isHidden'])
        .forEach((item) => {
          const firstChar =
            item.name[0] == ' ' ? item.name.replace(' ', '')[0].toLowerCase() : item.name[0].toLowerCase();
          const isAlpha = isAlphabet(firstChar);

          if (isAlpha) {
            letters[firstChar]['isActive'] = true;
          } else {
            letters['#']['isActive'] = true;
          }
        });
      return letters;
    },
  },
  watch: {
    'allBrands.length': {
      immediate: true,
      handler: function (length) {
        if (length && this.listsBrandsFinals.length === 0) {
          // eslint-disable-next-line vue/no-mutating-props
          this.listsBrandsFinals = this.allBrands.sort((a, b) => {
            return (a['name'] || '').localeCompare(b['name'] || '');
          });
        }
      },
    },
  },
  beforeDestroy() {
    this.listsBrandsFinals.forEach((brand) => (brand['isHidden'] = false));
  },
  methods: {
    buildIdElBrand(brand, idx) {
      const isAlphabet = (char) => char.match(/^[A-Za-z]+$/);
      const prevBrand = idx > 0 ? this.listsBrandsFinals[idx - 1] : null;
      const brandFirstChar = brand['name'][0].toLowerCase();
      const isAlpha = isAlphabet(brandFirstChar);
      if (isAlpha) {
        if (prevBrand !== null && prevBrand['name'][0] !== brandFirstChar) {
          return 'brand-' + brandFirstChar;
        }
      } else if (!isAlpha && prevBrand === null) {
        return 'brand-#';
      }
      return '';
    },
    applyFilter() {
      const value = this.$SO.size(this.filterBrands) ? this.filterBrands : '';
      this.$emit('applyFilter', value);
      this.closeModal();
    },
    buildStyle() {
      const windowHeight = window.innerHeight;
      const modalHeaderHeight = 47;
      const maxContentHeight = windowHeight - modalHeaderHeight;

      this.$refs.modalBodyFilterBrand.style.height = maxContentHeight + 'px';
      this.$refs.modalBodyFilterBrand.style.maxHeight = maxContentHeight + 'px';
    },
    closeModal() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'brands' });
    },
    searching() {
      this.$emit('searching', this.searchText);
    },
    selectBrand() {
      this.closeModal();
    },
    onKeyupSearchbrand(e) {
      const value = e.target.value.toLowerCase();
      const totalBrands = this.listsBrandsFinals.length;
      let i = 0;

      this.brandSearchName = value;
      // const obj = Object.entries(this.filteredBrands);
      this.listsBrandsFinals.forEach((brand, key) => {
        const brandNameToLowerCase = brand.name.toLowerCase();

        if (brandNameToLowerCase.includes(value)) {
          this.$set(this.listsBrandsFinals[key], 'isHidden', false);
          this.$SO('h4').removeClass('hidden');
        } else {
          this.$set(this.listsBrandsFinals[key], 'isHidden', true);
          i++;
          this.$SO('h4').addClass('hidden');
        }
      });

      this.isEmptyWhenTypingBrand = i === totalBrands;
    },
    toLetter(letter) {
      this.selectedLetter = letter;
      const topPos = document.getElementById('brand-letter-' + letter).offsetTop;
      const containerOffset = document.getElementById('brand-value-origin').offsetTop;
      document.getElementById('brand-value-origin').scrollTop = topPos - containerOffset;

      //   var defaultDuration = 400;
      //   var edgeOffset = 0;
      //   var myDiv = document.getElementById("brand-value");
      //   var myScroller = zenscroll.createScroller(myDiv, defaultDuration, edgeOffset);
      //   var target = document.getElementsByClassName(letter)[0];

      //   console.log(target, target.offsetTop, myDiv)

      //   // 189 is current offset top of myDiv
      //   myScroller.toY(target.offsetTop - 100);
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.isDesktop ? 'w=50' : 'w=40',
        image: src,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.modal-header) {
  position: relative;
  padding: 5px 0;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
}

:deep(.modal-body) {
  padding: 0 15px;
}

.modal-header-container {
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
  padding: 10px 20px;
}

.close-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  margin-right: 15px;
}
.hidden {
  display: none;
}
.modal-heading {
  font: 14px/18px 'lato-bold', sans-serif;
  color: #231f20;
  text-align: left;
  margin: 0;
}
.mega-menu-wrapper {
  .brands-menu-left {
    .search {
      width: 100%;
      position: relative;
      border-bottom: 1px solid #e5e5e5;
      padding: 10px;
      input.input-search {
        background: #fff;
        border: 1px solid #e5e5e5;
        font: 14px/17px Lato-Regular, sans-serif;
        color: #231f20;
        width: 100%;
        height: 40px;
        padding: 12px 12px 11px 34px;
        -o-border-radius: 4px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        &:focus {
          border: 1px solid #e5e5e5 !important;
          background: #fff;
        }
      }
      .icon-search {
        position: absolute;
        cursor: pointer;
        z-index: 1;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 55px;
        &:before {
          background: transparent url('~/assets/img/search-icon.svg') no-repeat 50%;
          -webkit-background-size: 18px 18px;
          -moz-background-size: 18px 18px;
          -o-background-size: 18px 18px;
          background-size: 18px 18px;
          content: '';
          width: 24px;
          height: 24px;
          display: flex;
        }
      }
    }
    .search-by-alpha {
      position: relative;
      width: 100%;
      border-bottom: 1px solid #e5e5e5;
      padding: 8px 4px;
      cursor: pointer;
      .brand-tag {
        text-align: center;
        font: 14px 'lato-regular', sans-serif;
        color: #e5e5e5;
        line-height: 25px;
        display: inline-block;
        text-transform: uppercase;
        height: 25px;
        width: 29px;
        border-radius: 100px;
        &:hover,
        &:focus {
          text-decoration: none;
        }
      }
      a.active {
        color: #231f20 !important;
        font-weight: 700 !important;
      }
      a.disabled {
        pointer-events: none;
      }
      .brand-show-all {
        display: inline-block;
        color: #b32656;
        letter-spacing: 0;
        font-size: 14px;
        line-height: 14px;
        font-family: 'lato', sans-serif;
        float: right;
        margin-top: 3px;
        img {
          display: inline-block;
          margin-left: 5px;
          vertical-align: inherit;
        }
      }
    }
    .brand-value {
      height: calc(100vh - 100px);
      max-height: 320px;
      margin-bottom: 0;
      padding-bottom: 12px;
      position: relative;
      overflow-y: scroll;
      scroll-behavior: smooth;
      .brand-val-list {
        padding: 0 20px 20px;
        h4 {
          font: 14px/20px 'lato-bold', sans-serif;
          color: #231f20;
          margin: 0px;
          text-transform: uppercase;
          padding: 10px 0;
        }
        ul {
          width: 100%;
          float: inherit;
          margin: 0;
          li {
            list-style: none;
            display: block;
            width: 100%;
            padding: 10px 0;
            a:link,
            a:visited {
              font: 14px Lato-Regular, sans-serif;
              color: #231f20;
              line-height: 20px;
              width: 100%;
              text-align: left;
              display: block;
              margin: 0px;
              padding: 0px;
              text-transform: inherit;
              letter-spacing: 0px;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .modal--full-fixed .modal-heading {
    font: 15px/15px 'lato-bold', sans-serif;
    color: #231f20;
    padding: 1px 0;
    margin: 0 0 0 30px;
    text-align: left;
  }

  .modal--full-fixed .modal-header .close {
    margin-top: -5px;
    right: 0 !important;
    left: 17px !important;
  }
  .mega-menu-wrapper .brands-menu-left .search-by-alpha {
    overflow: auto;
    white-space: nowrap;
  }
  .brand-val-list ul li {
    border-bottom: 1px solid #e5e5e5;
    padding: 10px !important;
  }
  .brand-val-list ul li a {
    font: 13px 'lato-regular', sans-serif !important;
    color: #231f20 !important;
    letter-spacing: 1.5px !important;
    text-transform: uppercase !important;
  }
  h4 {
    color: #231f20 !important;
    letter-spacing: 2px !important;
    font: 13px/20px 'lato-bold', sans-serif !important;
    border-bottom: 1px solid #e5e5e5;
    padding: 10px !important;
  }
}
</style>
